import { toggle } from "@otto-ec/global-resources/toggle";
import { ToggleKey } from "../../../constants/toggle";

export class LastSeenCinema {
  private _template: HTMLDivElement | null = null;
  private trackedOnce = false;

  private getHTMLTemplate(): HTMLDivElement {
    const container = document.querySelector(".js_squirrel_lastSeenCinemaContainer") as HTMLDivElement | null;
    if (!container) {
      /*                                                                                               */
      return document.createElement("div");
    }
    container.removeAttribute("style");
    const template = container;
    /*                                                                           */
    container.outerHTML = "";
    return template;
  }

  get template(): HTMLDivElement {
    if (!this._template) {
      this._template = this.getHTMLTemplate();
    }
    return this._template;
  }

  get hasContent(): boolean {
    if (!toggle.get(ToggleKey.LAST_SEEN_CINEMA, true)) {
      return false;
    }
    /*                                                                         */
    return this.template.childElementCount > 0;
  }

  trackLoadOnce(onFirstLoad: () => void): void {
    if (!this.trackedOnce) {
      this.trackedOnce = true;
      onFirstLoad();
    }
  }
}

export const lastSeenCinema = new LastSeenCinema();